import React, { useState } from "react";
import { loginEmailPassword } from "../lib/authLib";
import { useSnackbar } from "../contexts/SnackbarContext";

const Login = () => {
  const { showSnackbar } = useSnackbar();
  const [credentials, setCredentials] = useState({
    email: "",
    password: "",
  });

  const handleLogin = async () => {
    try {
      await loginEmailPassword(credentials.email, credentials.password);
      window.location.href = "/";
    } catch (error) {
      console.error("Error during Google authentication", error);
      // Show user-friendly error message
      if (error instanceof Error) {
        showSnackbar(error.message, "error");
      } else {
        showSnackbar("Failed to connect to the Cobutler API", "error");
      }
    }
  };

  return (
    <div className="min-h-screen bg-gray-900 flex flex-col justify-center items-center px-4">
      <div className="w-full max-w-md bg-gray-800 rounded-lg shadow-xl overflow-hidden border border-gray-700">
        <div className="p-6 sm:p-8">
          <div className="text-center">
            <img
              src="/logo-dark.png"
              alt="Cobutler Logo"
              className="w-48 h-auto mb-6 mx-auto"
            />
            <h1 className="text-2xl font-bold mb-2 text-white">
              Welcome to Cobutler
            </h1>
            <p className="text-gray-300 mb-4">
              Sign in to access your dashboard
            </p>
            <input
              type="text"
              name="email"
              placeholder="email"
              className="p-2 m-2 border rounded dark:bg-gray-700 dark:text-white dark:border-gray-600"
              onChange={(e) =>
                setCredentials({ ...credentials, email: e.target.value })
              }
              required
            />
            <input
              type="text"
              name="password"
              placeholder="password"
              className="p-2 m-2 border rounded dark:bg-gray-700 dark:text-white dark:border-gray-600"
              onChange={(e) =>
                setCredentials({ ...credentials, password: e.target.value })
              }
              required
            />
            <p className="text-gray-300 mb-8 text-xs">
              <i>
                Note: Most Cobutler users don't have a password. Try{" "}
                <a href="/login">logging in with Google</a> if you aren't sure
                you belong here!
              </i>
            </p>
          </div>

          <button
            onClick={handleLogin}
            className="w-full flex items-center justify-center gap-3 bg-blue-600 hover:bg-blue-700 text-white py-3 px-4 rounded-md transition-colors duration-200 font-medium"
          >
            Sign in
          </button>

          <div className="mt-8 text-center">
            <a
              href="mailto:hello@cobutler.com"
              className="text-blue-400 hover:text-blue-300 text-sm flex items-center justify-center gap-2"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                />
              </svg>
              Need help? Email us at hello@cobutler.com
            </a>
          </div>
        </div>

        <div className="bg-gray-700 px-6 py-4 text-center text-sm text-gray-300">
          <p>© {new Date().getFullYear()} Cobutler. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default Login;
